<template>
	<div class="container-fluid">
		<materials-tasks-toolbar v-if="!isSettingsComponent" title="Materials Settings"></materials-tasks-toolbar>

		<!--
		<widget title="Materials Pricing" icon="fa-dollar" class="row-padding">

			<p>Apply a default Price Adjustment and Markup to all invoiced materials. These can be over-ridden by specific Customer Settings, and adjusted on an invoice by invoice basis as well.</p>

			<vue-form :no-top-button="true" v-on:submit="savePricing" :working="pricingFormWorking">
				<field label="Default Price Adjustment (%)" v-if="'CompanySetting' in $store.company"
					col-class="col-md-4"
					:params="{type:'number',min:0,step:0.001,placeholder: 'ex. 1.20 for 20% adjustment'}"
					v-model="$store.company.CompanySetting.default_price_adjustment">
					<span class="text-muted">ex. 1.20 for 20% adjustment</span>
				</field>

				<field label="Default Markup (%)" v-if="'CompanySetting' in $store.company"
					col-class="col-md-4"
					:params="{type:'number',min:0,step:0.001,placeholder: 'ex. 1.20 for 20% markup'}"
					v-model="$store.company.CompanySetting.default_markup">
					<span class="text-muted">ex. 1.20 for 20% markup</span>
				</field>
			</vue-form>
		</widget>
		-->

		<widget title="Assemblies Tags" icon="fa-tag" class="row-padding">

			<form v-on:submit.prevent="saveTag">

				<div class="d-flex align-items-center">
					<label class="mr-2 mb-0 font-weight-bold">Add Tag</label>
					<field :params="{placeholder:'Tag Name'}" v-model="tagPayload.name"></field>
					<button 
						type="submit" 
						class="btn btn-success">
						<i class="fa fa-save"></i>
						Add
					</button>
				</div>

			</form>

			<table-list
				:records="tags"
				:fields="tagFields"
				record-name="Assembly Tag"
				:hide-record-count="true"
				:has-delete="true"
				:has-edit="true"
				:sortable="true"
				delete-endpoint="/AssemblyTag/delete"
				v-on:modelChange="fetchTags(true)"
				v-on:edit="editTag">
			</table-list>
			
		</widget>

	</div>
</template>
<script type="text/javascript">
import MaterialsTasksToolbar from "./MaterialsTasksToolbar"

import VueForm from "@/components/VueForm"
import Field from "@/components/Field"
import Widget from "@/components/Widget"
import TableList from "@/components/TableList"

export default {
	name: "MaterialsSettings",
	components: {
		MaterialsTasksToolbar,
		Field,
		VueForm,
		Widget,
		TableList
	},
	props: ["isSettingsComponent"],
	data() {
		return {
			pricingFormWorking: false,
			tagFields: [
				{label: "Tag Name",key:"name"}
			],
			tags: [],
			tagPayload: {

			}
		}
	},
	methods: {
		savePricing() {
			let vm = this

			let payload = {
				default_markup: this.$store.company.CompanySetting.default_markup,
				default_price_adjustment: this.$store.company.CompanySetting.default_price_adjustment
			}

			this.postData("CompanySetting/save",payload,true).then(response => {
				vm.pricingFormWorking = false

				if (response.success) {
					vm.alertSaved("Material pricing saved")
				}
			})
		},
		editTag(tag) {
			this.tagPayload = tag
		},
		saveTag() {
			let vm = this

			let payload = {
				name: this.tagPayload.name,
			}

			if ("id" in this.tagPayload)
				payload.id = this.tagPayload.id

			this.postData("AssemblyTag/save",payload).then(response => {
				if (response.success) {
					vm.alertSaved("Tag saved")
					vm.tagPayload = {
						name: ""
					}
					vm.fetchTags(true)
				}
			})
		},
		fetchTags(spinner) {
			let vm = this

			return new Promise((resolve,reject) => {

				if (spinner)
					vm.spinner(true)

				vm.getJSON("AssemblyTag/get").then(response => {
					if (response.success)
						vm.tags = response.data

					if (spinner)
						vm.spinner(false)

					resolve(response)
				})

			})
		},
		fetchData() {
			let vm = this

			this.fetchCompanyData(true,["CompanySetting"]).then(response => {
				if (response.success) {
					vm.$store.company = response.data
				}
			})

			this.fetchTags(false)
		}
	},
	created() {
		this.fetchData()
	}
}
</script>